import { motion } from 'framer-motion';
import ResponsiveImage from '../ResponsiveImage';

export default function Footer() {

    const quickLinks = [
        { label: 'Menu', path: '/menu' },
        { label: 'Merchandise', path: '/merchandise' },
        { label: 'Gift Cards', path: '/gift-cards' },
        { label: 'Loyalty Program', path: '/', scrollTo: 'loyalty' },
        { label: 'Store Locator', path: '/find-store' },
        { label: 'About Us', path: '/', scrollTo: 'about-us' },
    ];

    const supportLinks = [
        { label: 'Contact Us', path: '/contact' },
        { label: 'Store Inquiry', path: '/contact' },
        { label: 'Terms & Conditions', path: '/terms' },
        { label: 'Privacy Policy', path: '/privacy' },
    ];

    const handleLinkClick = (path, scrollTo) => {
        if (!window.REACT_APP_NAVIGATE) return;
        window.REACT_APP_NAVIGATE(path);

        if (scrollTo) {
            // wait a moment for the navigation to complete then scroll
            setTimeout(() => {
                const element = document.getElementById(scrollTo);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 100);
        } else {
            window.scrollTo(0, 0);
        }
    };
    return (
        <footer className="relative bg-[#C5A021] text-[#140B07] py-20 px-4 md:px-8">
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-12 mb-16">
                    <div>
                        <div className="h-20 w-auto mb-6">
                            <ResponsiveImage src="/logo.png" alt="The Chocolate Room" className="h-20 w-auto" sizes="120px" />
                        </div>
                        <p className="text-sm text-[#140B07]/80 leading-relaxed mb-6">
                            Crafting moments of indulgence since 2024. Where passion meets perfection in every bite.
                        </p>
                        <div className="flex gap-4">
                            {['ri-facebook-fill', 'ri-instagram-line', 'ri-twitter-x-line', 'ri-youtube-fill'].map((icon) => (
                                <motion.a
                                    key={icon}
                                    href="#"
                                    className="w-10 h-10 bg-[#140B07]/10 rounded-full flex items-center justify-center cursor-pointer"
                                    whileHover={{ scale: 1.1, backgroundColor: 'rgba(20, 11, 7, 0.2)' }}
                                    whileTap={{ scale: 0.95 }}
                                >
                                    <i className={`${icon} text-lg text-[#140B07]`}></i>
                                </motion.a>
                            ))}
                        </div>
                    </div>

                    <div>
                        <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
                        <ul className="space-y-3">
                            {quickLinks.map((link) => (
                                <li key={link.label}>
                                    <button
                                        onClick={() => handleLinkClick(link.path, link.scrollTo)}
                                        className="text-sm text-[#140B07]/80 hover:text-[#140B07] transition-colors cursor-pointer bg-transparent border-none p-0 text-left"
                                    >
                                        {link.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-lg font-semibold mb-6">Support</h4>
                        <ul className="space-y-3">
                            {supportLinks.map((link) => (
                                <li key={link.label}>
                                    <button
                                        onClick={() => handleLinkClick(link.path)}
                                        className="text-sm text-[#140B07]/80 hover:text-[#140B07] transition-colors cursor-pointer bg-transparent border-none p-0 text-left"
                                    >
                                        {link.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    
                </div>

                <div className="pt-8 border-t border-[#140B07]/20">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        <p className="text-sm text-[#140B07]/70">
                            © 2024 The Chocolate Room. All rights reserved. | GST: 07AABCT1234F1Z5
                        </p>
                        <a
                            href="https://www.barodaweb.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-sm text-[#140B07]/70 hover:text-[#140B07] transition-colors"
                        >
                            Powered by - Barodaweb : The e-Catalogue Designer
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
